import MarkdownQuestionParser from "./MarkdownQuestionParser";
import AnswerItem from "../common/AnswerItem";
import { IAnswerItemFactory } from "../types";

interface IState{
  pos: number,
  src: string,
  posMax: number,
  answerItems: AnswerItem[]
}

export default class MarkdownBodyParser {
  public fieldType: string
  public isTest: boolean
  public answerItems: AnswerItem[] = []
  public formLineStart: number
  public formLineEnd: number
  public textareaRowNumber: number = 0
  private currentLine: number = 0
  private lines: string[]

  // inline_selectのため
  private scopeId: number = 0;

  constructor (input: string) {
    if (input.length >= 2) {
      this.lines = input.split(/\n/);
      let lastLineBlank = true;
      this.currentLine = 0;
      for (let line of this.lines) {
        let currentLineBlank = "" == line.trim();

        if (!this.fieldType) {
          if (currentLineBlank) this.parseCurrentParagraph();
          else if (lastLineBlank) this.formLineStart = this.currentLine;
          if (this.fieldType && this.fieldType != "textfield") break;
        }

        this.parseCurrentLine(line);
        this.currentLine += 1;
        lastLineBlank = currentLineBlank;
      }
      if (!this.fieldType && (!this.formLineEnd || this.formLineEnd < this.formLineStart)) {
        this.formLineEnd = this.lines.length - 1;
        this.parseCurrentParagraph();
      }
    }
  }

  private parseCurrentLine(content) {
    for (let pos = 0; pos < content.length; pos++) {
      if (content[pos] == '$') {
        let state = {pos: pos + 1, src: content.slice(pos + 1), posMax: content.length, answerItems: []};
        let parser = new MarkdownQuestionParser(content.slice(pos + 1));
        if (parser && parser.found()) {
          if (parser.isTextfield) {
            this.fieldType = parser.fieldType;
            this.isTest = this.isTest || parser.isTest;
            const answerItem = new AnswerItem(parser.fieldType, parser.allotment, parser.label, parser.allotment != null);
            this.answerItems.push(answerItem);
          }

          if (parser.isInlineSelect) {
            this.fieldType = parser.fieldType;
            this.isTest = this.isTest || parser.isTest;

            parser.answerItemScopes.forEach(answerItems => {
              this.scopeId++;
              this.answerItems = [...this.answerItems, ...answerItems.map(answerItem => answerItem.cloneNew(this.scopeId + answerItem.scopeId))]
            })
          }
        }
      }
    }
  }

  private parseCurrentParagraph() {
    if (this.formLineStart == null) return;

    this.formLineEnd = this.currentLine - 1;
    let paragraph = this.lines.slice(this.formLineStart, this.formLineEnd + 1).join("\n");
    this.parse(paragraph);
  }

  private parse(input: string) {
    if (this.fieldType) return;

    let state:IState = {pos: 0, src: input, posMax: input.length, answerItems: []};
    let parser = this.replace(state);
    let lastParser = parser;

    if (state.src.charCodeAt(0) !== 36 /* $ */ || state.posMax < 2) { return false; }
    if (parser) {
      this.fieldType = parser.fieldType;
      this.isTest = parser.isTest;
    }
    while (parser && parser.found() && state.pos <= state.posMax) {
      parser = this.replace(state, this.fieldType);
      lastParser = parser;
      if (parser && parser.fieldType) {
        this.fieldType = parser.fieldType;
        this.isTest = this.isTest || parser.isTest;
      }
    }

    if (!this.fieldType) return;

    this.answerItems = state.answerItems;
  }

  private replace(state: IState, fieldType:string = null) {
    let answerItem: AnswerItem;

    const max = state.posMax;
    const start = state.pos;

    if (state.src.charCodeAt(start) !== 36 /* $ */) { return null; }
    state.pos = start + 1;
    while (state.pos < max) {
      if (state.src.charCodeAt(state.pos) == 10) {
        state.pos += 1;
        break;
      }
      state.pos += 1;
    }
    const lastPos = state.pos;
    let content = state.src.slice(start + 1, state.pos);
    let parser = new MarkdownQuestionParser(content, fieldType);
    if (parser.found()) {
      state.pos = start;

      if (parser.isTextarea) {
        parser.getTextareaAnswerItems().forEach(answerItem => state.answerItems.push(answerItem))
        this.textareaRowNumber = parser.data.length
      } else if(parser.isInlineSelect){
        parser.answerItemScopes.forEach(answerItems => {
          this.scopeId++;
          this.answerItems = [...this.answerItems, ...answerItems.map(answerItem => answerItem.cloneNew(this.scopeId + answerItem.scopeId))]
        })
      } else {
        if (parser.isMultiCheckbox) {
          if (parser.allotment != null) {
            answerItem = new AnswerItem("point", parser.allotment, parser.label, parser.correct);
          } else {
            answerItem = new AnswerItem(parser.fieldType, parser.allotment, parser.label, parser.correct);
          }
          state.answerItems.forEach((ai: AnswerItem) => {
            ai.name = parser.fieldType
          });
        }  else {
          answerItem = new AnswerItem(parser.fieldType, parser.allotment, parser.label, parser.correct);
        }
        state.answerItems.push(answerItem);
      }

      state.pos = lastPos;
    }

    return parser;
  }
}
